import { pipe, prop, defaultTo } from 'ramda'
import { useQuery } from '@tanstack/react-query'
import client from '@/ports/api-client'

const formatter = pipe(prop('listing_contract_addendum_templates'), defaultTo({}))

async function getData() {
  const data = await client.get('/users/bootstrap/acts')
  return formatter(data)
}

const useContractAddendumTemplates = config => {
  const { data } = useQuery({
    queryKey: ['contract', 'addendum-templates'],
    queryFn: getData,
    staleTime: 30000,
    ...config
  })
  return data
}

export default useContractAddendumTemplates
